// extracted by mini-css-extract-plugin
export var base = "_2h-0";
export var updateBanner = "_2h-1";